import { Edge } from '@swimlane/ngx-graph';
import { ColumnDefinition } from '../domainObjects/columnDefinition';
import { DataConnectorMapping } from '../domainObjects/dataConnectorMapping';
import { DataSourceType } from '../domainObjects/dataSourceType';
import { DataTransform } from '../domainObjects/dataTransform';
import { PreviewDataOptions } from '../domainObjects/previewDataOptions';
import { CacheKeyType } from '../domainObjects/transformType';

export class TransformResultData {
    columns: ColumnDefinition[];
    rows: { [name: string]: string };
    totalRows: number;
}

export class RunConfigRequest {
    dryRun = true;
    dataSourceType: DataSourceType;

    // Determine if the response should return the results or just run the config
    requireResults = true;

    activeIngestFarmId?: string;

    // Active Transform
    activeTransformId?: string;

    // All the transforms guids downstream of the current
    downstreamTransformGuids: string[];

    // Optional Input Transform Id used as input data frame for transform pipeline single request per transform
    inputTransformGuid?: string;

    // DataConnectors
    dataConnectorMappings: DataConnectorMapping[];

    // List of transforms
    transforms: DataTransform<any>[];

    // Preview options for current transform results
    previewOptions?: PreviewDataOptions;

    // Preview options for current data farm out results
    farmDataOutPreviewOptions?: PreviewDataOptions;

    // All the Parent Nodes connected to Node
    DataConnectorNodes?:  Edge[];

    // All the Attribution Nodes Connected to the Node
    AttrConnectorNodes?:  Edge[];
    refineryID?: string;
    transformerRunType: string;
    previewType: number;

    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    cacheKeyType:CacheKeyType;

    /** Compiled operations plan for the fast compiled engine path. Null = use DTR. */
    compiledConfig?: any;
}

export class RunConfigResponse {
    resultData: TransformResultData;
}

export class RunCurrentConfigRequest {
    // List of transforms
    transforms: DataTransform<any>[];

    // Preview options for current transform results
    previewOptions?: PreviewDataOptions;

    // Preview options for current data farm out results
    farmDataOutPreviewOptions?: PreviewDataOptions;

    // For cache key
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;

    // For Input cache key
    inputNodeId: string;
    inputTransformId: string;
    inputCacheKeyType:CacheKeyType;
}
